export default __webpack_public_path__ + "static/Capannoni-298a837b809af7e4082a1e9ec59a6ba0.jpg";